<template>
    <!--<section class="about bg-white">
      <div class="shell-fluid shell-condensed">      
        <div>
          <h1>Ukratko o nama</h1>
          <div class="range range-50 range-sm-center range-md-left">
            <div class="cell-sm-6 cell-md-5">
              <div class="thumb-bordered"><img src="./../../images/aboutUs/aboutUs.jpg" alt="" width="437" height="435">
              </div>
            </div>
            <div class="cell-sm-6 cell-md-7">
              <div class="box-width-3 box-centered">
                <article class="quote-big">
                  <p class="q">{{ description }}</p>
                </article>
                <div class="divider"></div>
                <p class="text-spacing-05">{{ text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </section>  -->
  <section class="section bg-white section-md">
        <div class="shell-fluid">
          <h1>O NAMA</h1>
          <div class="range range-ten range-condensed range-50 range-sm-0">
            <div class="cell-sm-4 cell-md-3 cell-xl-3 cell-image-wrap">
              <img src="./../../images/aboutUs/aboutUs.jpg" alt="" height="450">
            </div>
            <div class="cell-sm-6 cell-lg-5 cell-xl-7 cell-sm-middle">
              <div class="box-spacer">
                <article class="quote-big">
                  <div class="q" v-html="text"></div>
                </article>
                <div class="divider"></div>
                <div v-html="description_short"></div>
                <router-link to="onama" class="button button-primary-outline button-ujarak button-size-1">Više</router-link>
              </div>
            </div>
          </div>
        </div>
  </section>    
</template>

<script>
import axios from 'axios';

export default {
   data(){
      return{
          title:'',
          text:'',
          description_short:'',
          image:''
        }
   },
   methods:{
      fetchData(){
        var url = this.apiPath + 'about_us/read.php';
        axios({
          method: 'get',
          url: url,
        })
        .then(function(response) {
          this.title = response.data.Title;
          this.text = response.data.Text;
          this.description_short = response.data.DescriptionShort;
          this.image = response.data.Image;
        }.bind(this))
        .catch((error) => {
          console.log(error);
        });  
      }
   },
   created(){
       this.fetchData();
   }   
}
</script>

<style lang="scss">


@media only screen and (max-width: 768px) {

}  
</style>


// WEBPACK FOOTER //
// src/components/Home/OnamaHome.vue